export default {
  //API_URL: 'https://api-cts.herokuapp.com'
  API_URL: "https://api.acrosstech.cloud/cts-public",
};
